import { ROLES } from '@/constants/roles';
import { isVcht } from '@/constants/global';

import memberImage from '@/assets/instructions/illustration-member.svg';
import expertImage from '@/assets/instructions/illustration-expert.svg';
import trainerImage from '@/assets/instructions/illustration-trainer.svg';
import organizationsImage from '@/assets/instructions/illustration-organizations.svg';

import memberImagePng from '@/assets/instructions/illustration-member.png';
import expertImagePng from '@/assets/instructions/illustration-expert.png';
import trainerImagePng from '@/assets/instructions/illustration-trainer.png';
import organizationsImagePng from '@/assets/instructions/illustration-organizations.png';

import EmbedYoutube from '@/components/EmbedYoutube.vue';

export const ROLES_INSTRUCTIONS = {
  [ROLES.member]: {
    text: 'Я - участник мероприятий',
    title: 'Как стать участником',
    image: isVcht ? memberImagePng : memberImage,
    registerLink: { path: '/register', query: { role: ROLES.member } },
    steps: [
      {
        title: 'Зарегистрируйтесь в качестве участника олимпиады',
        component: EmbedYoutube,
        component_attrs: {
          src: isVcht ? 'https://youtu.be/XaWRF8XNtC0'  : 'https://youtu.be/2dQ7m6d8B0k',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Авторизуйтесь в личном кабинете на портале',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://www.youtube.com/watch?v=VN-AeFw6XBM',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Подайте заявку на участие в олимпиаде',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/Kw3uo-J685o',
          stop: true,
          style: { border: 'none' },
        },
      },
    ],
  },
  [ROLES.organization]: {
    text: 'Я - организатор мероприятий',
    title: 'Как стать организатором',
    image: isVcht ? organizationsImagePng : organizationsImage,
    registerLink: { path: '/register', query: { role: ROLES.organization } },
    steps: [
      {
        title: 'Зарегистрируйтесь в качестве соорганизатора',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/mbus9pueN64',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Авторизуйтесь в личном кабинете на портале',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/VN-AeFw6XBM',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Подайте заявку на бирже мероприятий',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/AaqiyJ0Rxrk',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Создайте мероприятия школьного этапа',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/aB2jTAwGIBc',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Расскажите ученикам школы о вашем мероприятии',
      },
    ],
  },
  [ROLES.trainer]: {
    text: 'Я - наставник',
    title: 'Как стать наставником',
    image: isVcht ? trainerImagePng : trainerImage,
    registerLink: { path: '/register', query: { role: ROLES.trainer } },
    steps: [
      {
        title: 'Зарегистрируйтесь в качестве руководителя коллектива',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://youtu.be/qnrqNK4goBw',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Авторизуйтесь в личном кабинете на портале',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://www.youtube.com/watch?v=VN-AeFw6XBM',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Создайте свою команду',
      },
      {
        title: 'Подайте заявку на участие в мероприятии',
      },
    ],
  },
  [ROLES.expert]: {
    text: 'Я - эксперт',
    title: 'Как стать экспертом',
    image: isVcht ? expertImagePng : expertImage,
    registerLink: { path: '/register', query: { role: ROLES.expert } },
    steps: [
      {
        title: 'Зарегистрируйтесь в качестве эксперта',
      },
      {
        title: 'Авторизуйтесь в личном кабинете на портале',
        component: EmbedYoutube,
        component_attrs: {
          src: 'https://www.youtube.com/watch?v=VN-AeFw6XBM',
          stop: true,
          style: { border: 'none' },
        },
      },
      {
        title: 'Подайте заявку на участие в олимпиаде в качестве эксперта',
      },
    ],
  },
};
